webpackJsonp([16],{

/***/ 1935:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1954),
  /* template */
  __webpack_require__(2017),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1954:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_services_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_utils_estados_brasileiros__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_mask__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers_money__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_money__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  directives: { mask: __WEBPACK_IMPORTED_MODULE_4_v_mask__["a" /* VueMaskDirective */], money: __WEBPACK_IMPORTED_MODULE_6_v_money__["VMoney"] },
  nome: 'extrato-leilao-form',
  props: {
    extratoId: {
      type: Number
    }
  },
  data: function data() {
    return {
      money: __WEBPACK_IMPORTED_MODULE_5__utils_helpers_money__["a" /* REAL_BRL */],
      isLoading: false,
      isLoaded: false,
      cadastroError: null,
      atualizadoSucesso: null,
      data: {
        placa: null,
        chassi: null,
        observacao: null,
        descricaoLeilao: null,
        dataLeilao: null,
        tipoDocumentoLeiloeiro: 1,
        cpfCnpjLeiloeiro: null,
        tipoDocumentoArrematante: 1,
        cpfCnpjArrematante: null,
        nomeArrematante: null,
        enderecoArrematante: null,
        numeroEndArrematante: null,
        complementoEndArrematante: null,
        bairroEndArrematante: null,
        ufEndArrematante: null,
        codigoMunicipioArrematante: null,
        nomeMunicipioArrematante: null,
        cepEndArrematante: null,
        numeroNotaFiscal: null,
        dataNotaFiscal: null,
        valorNotaFiscal: null,
        renavam: null,
        diarioOficial: null,
        dataDiarioOficial: null
      },
      loadingCidades: false,
      listaCidades: [],
      extratoCadastrado: false
    };
  },

  computed: {
    estadosBr: function estadosBr() {
      return __WEBPACK_IMPORTED_MODULE_3__default_utils_estados_brasileiros__["a" /* default */];
    },
    cidadesFiltered: function cidadesFiltered() {
      var cidades = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["uniqBy"])(this.listaCidades, function (item) {
        return item.Codigo;
      });
      return cidades.filter(function (item) {
        return item.Codigo !== 0;
      });
    },
    cidadeSelecionada: function cidadeSelecionada() {
      var _this = this;

      return this.listaCidades.find(function (item) {
        return item.Codigo === _this.data.codigoMunicipioArrematante;
      });
    }
  },
  mounted: function mounted() {
    this.start();
  },
  activated: function activated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    start: function start() {
      var _this2 = this;

      if (this.$route.params.id) {
        this.$loaderOverlay.open().message('Carregando');
        __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_services_index__["a" /* default */].getExtratoLeilaoInfo(this.$route.params.id).then(function (response) {
          _this2.isLoaded = true;
          _this2.$loaderOverlay.hide();
          _this2.data = response.data;
          _this2.loadMuncipiosEstado();
          console.log(response);
        }).catch(function (response) {
          _this2.$loaderOverlay.hide();
          console.log(response);
        });
      } else {
        this.isLoaded = true;
      }
    },
    submit: function submit() {
      var _this3 = this;

      if (this.extratoId) {
        return;
      }
      if (this.loadingCidades) {
        alert('Aguarde, carregando lista de municípios do service DETRO...');
        return;
      }
      this.cadastroError = null;
      this.atualizadoSucesso = false;
      this.$loaderOverlay.open().message('Processando...');
      this.$bar.start();
      window.setTimeout(function () {
        _this3.$loaderOverlay.message('Aguarde...');
      }, 1000);
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));
      data.valorNotaFiscal = this.converterParaFormatoN15(data.valorNotaFiscal);
      __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_services_index__["a" /* default */].cadastrarExtratoLeilao(this.$route.params.id, data).then(function (response) {
        var callbackEnd = function callbackEnd() {
          _this3.$bar.finish();
          _this3.$loaderOverlay.hide();
          if (_this3.$route.params.id) {
            _this3.atualizadoSucesso = true;
            _this3.$el.querySelector('#sucessMsg').focus();
          } else {
            _this3.atualizadoSucesso = true;
          }
          _this3.extratoCadastrado = true;
          _this3.$emit('finishSubmit');
        };
        callbackEnd();
      }).catch(function (response) {
        _this3.$bar.finish();
        _this3.$loaderOverlay.hide();
        _this3.cadastroError = response.data.errors;
        _this3.$nextTick(function () {
          _this3.$refs.error.focus();
        });
        console.log(response);
      });
    },

    loadMuncipiosEstado: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function () {
      var _this4 = this;

      this.loadingCidades = true;
      this.listaCidades = [];
      __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_services_index__["a" /* default */].getMunicipiosEstadoDetro(this.data.ufEndArrematante).then(function (response) {
        _this4.listaCidades = response.data;
        _this4.loadingCidades = false;
      }).catch(function (error) {
        _this4.loadingCidades = false;
        alert('Houve um erro ao obter a lista de municípios:\n' + _this4.printError(error.data.errors));
      });
    }, 500),
    cancel: function cancel() {
      this.$emit('cancel');
    },
    printError: function printError(err) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isArray"])(err)) {
        return err[0];
      }
      return err;
    },
    converterParaFormatoN15: function converterParaFormatoN15() {
      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return str.replace(/\D/g, '').padStart(15, '0');
    },
    leiloeiroStandart: function leiloeiroStandart() {
      var cpf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '10935812717';

      this.data.tipoDocumentoLeiloeiro = 1;
      this.data.cpfCnpjLeiloeiro = cpf;
    }
  }
});

/***/ }),

/***/ 2017:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition",
    style: (_vm.extratoId ? 'background-color: #f7de69;' : '')
  }, [(_vm.extratoId) ? _c('div', {
    staticClass: "bg-warning lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h4 text-black"
  }, [_c('strong', [_vm._v("Atenção")]), _c('br'), _vm._v("\n            Este lote já possui um extrato cadastrado. Você está visualizando os dados, não sendo possível alterá-los.\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Cadastro de Extrato de Leilão")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-sm"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (!_vm.extratoCadastrado) ? _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Placa")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.placa),
      expression: "data.placa"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.placa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "placa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Chassi")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.chassi),
      expression: "data.chassi"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.chassi)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "chassi", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Renavam")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.renavam),
      expression: "data.renavam"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.renavam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "renavam", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Observação")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.observacao),
      expression: "data.observacao"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.data.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "observacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Data do Leilão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.dataLeilao),
      expression: "data.dataLeilao"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "date"
    },
    domProps: {
      "value": (_vm.data.dataLeilao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "dataLeilao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Título do Leilão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.descricaoLeilao),
      expression: "data.descricaoLeilao"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.data.descricaoLeilao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "descricaoLeilao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Tipo de documento do Leiloeiro")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tipoDocumentoLeiloeiro),
      expression: "data.tipoDocumentoLeiloeiro"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "tipoDocumentoLeiloeiro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 1
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("CNPJ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Documento do Leiloeiro")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cpfCnpjLeiloeiro),
      expression: "data.cpfCnpjLeiloeiro"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.data.tipoDocumentoLeiloeiro === 1 ? '###.###.###-##' : '##.###.###/####-##'),
      expression: "data.tipoDocumentoLeiloeiro === 1 ? '###.###.###-##' : '##.###.###/####-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.cpfCnpjLeiloeiro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cpfCnpjLeiloeiro", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Tipo de documento do Arrematante")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tipoDocumentoArrematante),
      expression: "data.tipoDocumentoArrematante"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "tipoDocumentoArrematante", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("CNPJ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Documento do Arrematante")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cpfCnpjArrematante),
      expression: "data.cpfCnpjArrematante"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.data.tipoDocumentoArrematante === 1 ? '###.###.###-##' : '##.###.###/####-##'),
      expression: "data.tipoDocumentoArrematante === 1 ? '###.###.###-##' : '##.###.###/####-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "autocomplete": "off",
      "id": "numeroDocumento",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.cpfCnpjArrematante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cpfCnpjArrematante", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Nome do Arrematante")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nomeArrematante),
      expression: "data.nomeArrematante"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.nomeArrematante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nomeArrematante", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Endereço do Arrematante")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.enderecoArrematante),
      expression: "data.enderecoArrematante"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.enderecoArrematante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "enderecoArrematante", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Número")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.numeroEndArrematante),
      expression: "data.numeroEndArrematante"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.numeroEndArrematante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "numeroEndArrematante", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.complementoEndArrematante),
      expression: "data.complementoEndArrematante"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.complementoEndArrematante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "complementoEndArrematante", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bairroEndArrematante),
      expression: "data.bairroEndArrematante"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.bairroEndArrematante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bairroEndArrematante", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.ufEndArrematante),
      expression: "data.ufEndArrematante"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "ufEndArrematante", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadMuncipiosEstado]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.estadosBr), function(estado) {
    return _c('option', {
      key: estado.sigla,
      domProps: {
        "value": estado.sigla
      }
    }, [_vm._v(_vm._s(estado.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Município do Arrematante")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.loadingCidades) ? _c('select', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "required": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Carregando...")])]) : (_vm.extratoId) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nomeMunicipioArrematante),
      expression: "data.nomeMunicipioArrematante"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.nomeMunicipioArrematante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nomeMunicipioArrematante", $event.target.value)
      }
    }
  }) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.codigoMunicipioArrematante),
      expression: "data.codigoMunicipioArrematante"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "codigoMunicipioArrematante", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.data.nomeMunicipioArrematante = _vm.cidadeSelecionada.Nome
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.cidadesFiltered), function(cidade) {
    return _c('option', {
      key: cidade.Codigo,
      domProps: {
        "value": cidade.Codigo
      }
    }, [_vm._v(_vm._s(cidade.Nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##.###-###'),
      expression: "'##.###-###'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cepEndArrematante),
      expression: "data.cepEndArrematante"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.cepEndArrematante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cepEndArrematante", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Número da Nota Fiscal")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.numeroNotaFiscal),
      expression: "data.numeroNotaFiscal"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.numeroNotaFiscal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "numeroNotaFiscal", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Data da Nota Fiscal")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.dataNotaFiscal),
      expression: "data.dataNotaFiscal"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "date"
    },
    domProps: {
      "value": (_vm.data.dataNotaFiscal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "dataNotaFiscal", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Valor da Nota Fiscal")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.valorNotaFiscal),
      expression: "data.valorNotaFiscal"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.valorNotaFiscal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "valorNotaFiscal", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Número do Diário Oficial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.diarioOficial),
      expression: "data.diarioOficial"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.diarioOficial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "diarioOficial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Data do Diário Oficial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.dataDiarioOficial),
      expression: "data.dataDiarioOficial"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "date"
    },
    domProps: {
      "value": (_vm.data.dataDiarioOficial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "dataDiarioOficial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.extratoId) ? _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    attrs: {
      "type": "submit"
    }
  }, [(!_vm.data.id) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancelar")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.extratoCadastrado) ? _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-check-circle text-success",
    staticStyle: {
      "font-size": "150px"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Extrato cadastrado!")])])])])])]) : _vm._e()], 1)])])]) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/16.67ede983d7a1152c2387.js